import type { PlanFeatureInput } from '@frameio/graphql-client/generated';

export const INVITED_TO_ID = 'invitedToSection';
export const NEW_WORKSPACE_ID = 'new-workspace-id';
export const CREATE_PROJECT_CARD_SUFFIX = 'create-project-card';
export const NO_MATCH_SUFFIX = 'no-match';
export const PROJECT_CARD_ASPECT_RATIO = [200, 228] as [number, number];
export const PLACEHOLDER_PROJECT_ID_PREFIX = 'placeholder-project-card';

export const RESTRICTED_PROJECTS_FEATURE_INPUT: PlanFeatureInput =
  'PRIVATE_PROJECTS';

/** Specifies the minimum project threshold for showing/hiding recent projects list */
export const RECENT_PROJECTS_THRESHOLD = 20;
